import { useAppDispatch } from 'store/hooks';
import settingStaffSelectors from '../selectors';
import settingStaffActions from '../actions';
import { useEffect } from 'react';

const useGetDetailServicePrice = (staffId: string) => {
  const dispatch = useAppDispatch();
  const detailServicePrice = settingStaffSelectors.getDetailServicePrice();

  const mutate = (staffId: string) => {
    dispatch(settingStaffActions.getDetailServicePrice.fetch(staffId));
  };

  useEffect(() => {
    mutate(staffId);
  }, [staffId]);

  return {
    detailServicePrice,
    mutate,
  };
};
export default useGetDetailServicePrice;
